/** 用户类型 */
enum UserType {
    普通用户 = 'COMMON_USER',
    公司管理员 = 'COMPANY_ADMIN',
    超级管理员 = 'SUPER_ADMIN',
}

export default UserType;


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/entry/constant/UserType/index.ts